// Contexto para armazenar o login do usuário autenticado (alimentado pelo Auth/JWT)

import React, { createContext, useState } from "react";

export const UsuarioLogadoContext = createContext()

export const UsuarioLogadoContextProvider = ({ children }) => {
    // Sem hardcode 'Waleria': valor vem do Auth via SyncAuthContexts
    const [usuarioLogadoContext, setUsuarioLogadoContext] = useState('')

    return (
        <UsuarioLogadoContext.Provider value={{ usuarioLogadoContext, setUsuarioLogadoContext }}>
            {children}
        </UsuarioLogadoContext.Provider>
    )
}
